<template>
  <div class="marcas-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Canales">
          <b-table hover 
              responsive="sm"
              class="registro" 
              :busy="tableBusy"
              :items="canales" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Canal</b-dropdown-item>
                <!-- <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Banco</b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'canales/getField',
  mutationType: 'canales/updateField',
});

export default {
  name: 'CanalesList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        { key: 'nombre' },
        { 
          key: 'inactivo',
          class: 'text-center'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'canales',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'incluirInactivos'
    ]),
  },
  created() {
    this.getItems()
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('canales/getCanales')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'CanalData', 
                          params: { id: item.id }});
    },
    editar (item) {
      this.$router.push({ name: 'CanalEdit', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'CanalAdd' });
    },
    // borrar (item) {
    //   this.showModalConfirm('¿Desea inactivar el banco seleccionado?', 
    //         this.inactivar.bind(this, item.id), 'Si', null, 'No')
    // },
    // inactivar (bancoId) {
    //   this.showSpinner();
    //   this.$store.dispatch('banco/inactivar', bancoId)
    //     .then(() => this.showModalMsj('El banco seleccionado se inactivó con éxito.', this.getItems, this.getItems, 'light'))
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // },    
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .marcas-list .registro table td[aria-colindex="1"] {
    width: calc(90% - 60px);
  }
  .marcas-list .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .marcas-list .registro table td[aria-colindex="3"] {
    width: 60px;
  }
</style>
